import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import Logo from './Logo'
import CardNav from './CardNav'
import Container from './Container'

const StyledContainer = styled(Container)`
  background: #fff;
  position: relative;
  z-index: 1;
`

const Element = styled.header`
  display: flex;
  align-items: center;

  @media (max-width: 860px) {
    flex-direction: column;
  }
`

const Left = styled.div`
  @media (max-width: 860px) {
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    padding-right: 50px;
  }
`

const Right = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;

  @media (max-width: 860px) {
    margin: 0;
    width: 100%;
    /* display: none; */
    height: 0;
    transform: scale(0);
    transition: transform 0.25s ease;
    transform-origin: left center;

    ${props =>
      props.open &&
      css`
        height: auto;
        display: block;
        transform: scale(1);
      `}
  }
`

const Control = styled.button`
  display: block;
  width: 24px;
  height: 16px;
  background: none;
  margin: 0;
  position: absolute;
  top: 23px;
  right: 20px;
  display: none;
  border: 0;
  outline: none;
  cursor: pointer;

  &::before,
  &::after {
    content: '';
    display: block;
    height: 3px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #75787b;
    transition: all 0.25s ease;
  }

  &::after {
    top: auto;
    bottom: 0;
  }

  ${props =>
    props.disableNav &&
    css`
      display: none !important;
    `}

  @media (max-width: 860px) {
    display: block;
    transition: opacity 0.25s ease;

    ${props =>
      props.open &&
      css`
        &::before {
          transform: rotate(-45deg);
          top: 6px;
        }

        &::after {
          transform: rotate(45deg);
          bottom: 6px;
        }

        ${ControlInner} {
          opacity: 0;
        }
      `}
  }

  @media (max-width: 480px) {
    top: 18px;
  }
`

const ControlInner = styled.span`
  display: block;
  height: 3px;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  background: #75787b;
`

const Meta = styled.div`
  @media (max-width: 860px) {
    margin-bottom: 16px;
  }

  @media (max-width: 480px) {
  }
`

class Header extends React.Component {
  state = {
    showCardsOnMobile: false,
  }

  toggleCardsOnMobile = () => {
    this.setState({
      showCardsOnMobile: !this.state.showCardsOnMobile,
    })
  }

  render() {
    const {
      cardLinks,
      currentCard,
      currentVariant,
      disableBlue,
      disableGreen,
      disableNav,
      meta,
      metaOnMobile,
      disableCompare,
    } = this.props

    return (
      <StyledContainer>
        <Element>
          <Control
            disableNav={disableNav}
            onClick={() => this.toggleCardsOnMobile()}
            open={this.state.showCardsOnMobile}>
            <ControlInner />
          </Control>
          <Left>
            <Logo />
          </Left>
          <Right open={this.state.showCardsOnMobile || metaOnMobile}>
            {!disableNav && (
              <CardNav
                cardLinks={cardLinks}
                currentCard={currentCard}
                currentVariant={currentVariant}
                disableBlue={disableBlue}
                disableGreen={disableGreen}
                disableCompare={disableCompare}
              />
            )}
            <Meta>{meta}</Meta>
          </Right>
        </Element>
      </StyledContainer>
    )
  }
}

Header.propTypes = {
  cardLinks: PropTypes.object,
  currentCard: PropTypes.string,
  currentVariant: PropTypes.string,
  disableBlue: PropTypes.bool,
  disableNav: PropTypes.bool,
  meta: PropTypes.node,
  disableCompare: PropTypes.bool,
}

export default Header
